import { render, staticRenderFns } from "./property.vue?vue&type=template&id=7b26e215"
import script from "./property.vue?vue&type=script&lang=js"
export * from "./property.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\zkdn_workspace\\zhijiao\\bjzyjy-mhwz\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7b26e215')) {
      api.createRecord('7b26e215', component.options)
    } else {
      api.reload('7b26e215', component.options)
    }
    module.hot.accept("./property.vue?vue&type=template&id=7b26e215", function () {
      api.rerender('7b26e215', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/backstage/webSet/basic/property.vue"
export default component.exports